
function BasketButtonFixed() {
    $(window).scroll(function () {

        if ($("body").hasClass("Scrolled")) {

            $("#Basket").addClass("BasketFixed");

        }
        else {
            $("#Basket").removeClass("BasketFixed");
        }

    });
}

function HeaderFixer() {
    $(window).scroll(function () {

        if ($("body").hasClass("Scrolled")) {

            $("header").addClass("fixedHeader");

        }
        else {
            $("header").removeClass("fixedHeader");
        }

    });
}

function TextBanner() {
    $PrevSelectedDesktop = $("#AnoncementArea ul.desktopSlide li.selectedBannerDesktop")
    $PrevSelectedDesktop.removeClass("selectedBannerDesktop")
    if ($("#AnoncementArea ul.desktopSlide li").length != $PrevSelectedDesktop.index() + 1) {
        $PrevSelectedDesktop.next().addClass("selectedBannerDesktop");
    } else {
        $("#AnoncementArea ul.desktopSlide li").first().addClass("selectedBannerDesktop");
    }

    $PrevSelectedMobile = $("#AnoncementArea ul.mobileSlide li.selectedBannerMobile")
    $PrevSelectedMobile.removeClass("selectedBannerMobile")
    if ($("#AnoncementArea ul.mobileSlide li").length != $PrevSelectedMobile.index() + 1) {
        $PrevSelectedMobile.next().addClass("selectedBannerMobile");
    } else {
        $("#AnoncementArea ul.mobileSlide li").first().addClass("selectedBannerMobile");
    }

}

function settingTextBanner() {
    setInterval(TextBanner, 7000);
}

function GetLayoutTextBanners() {
    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetTextBannerList",
        success: function (dt) {
            if (dt.length > 0) {
                var desktopCounter = 0;
                var mobileCounter = 0;
                for (var i = 0; i < dt.length; i++) {
                    if (dt[i].Area == 12) {
                        if (desktopCounter == 0) {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        } else {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        }
                    } else {
                        if (mobileCounter == 0) {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md selectedBannerMobile'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        } else {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        }
                    }


                }
            }
            settingTextBanner();
        }
    });
}

function getAnoncementBanner() {

    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetAnoncementBanner",
        data: "SmallLangCode=" + $("#SmallLangCode").val(),
        success: function (dt) {
            if (dt.length > 0) {

                var desktopCounter = 0;
                var mobileCounter = 0;

                for (var i = 0; i < dt.length; i++) {

                    //Web
                    if (dt[i].BannerShowPlace == 157 && desktopCounter == 0 && $(window).width() > 767) {

                        //$("#AnoncementArea").css("height", "80px").css("max-height", "80px").css("overflow", "hidden").css("background-image", "linear-gradient(rgb(26, 53, 245), rgb(120, 111, 207), rgb(205, 164, 171))");

                        $("#AnoncementArea").css("height", "80px")
                            .css("max-height", "80px")
                            .css("overflow", "hidden")
                            .css("background-color", "#edc3a5");

                        $("#AnoncementArea ul").css("padding", "0");

                        $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><img src='" + dt[i].ImagePath + "' style='height: 75px;overflow: hidden;'></li>");

                        desktopCounter++;

                        $("body").addClass("ActiveAnoncementBanner");
                        $("#AnoncementArea").addClass("ActiveAnoncement");
                    }

                    //Mobile
                    else if (dt[i].BannerShowPlace == 158 && mobileCounter == 0 && $(window).width() < 768) {

                        //$("#AnoncementArea").css("height", "43px").css("max-height", "43px").css("overflow", "hidden").css("background-image", "linear-gradient(rgb(26, 53, 245), rgb(120, 111, 207), rgb(205, 164, 171))");

                        $("#AnoncementArea").css("height", "43px")
                            .css("max-height", "43px")
                            .css("overflow", "hidden")
                            .css("background-color", "#edc3a5");

                        $("#AnoncementArea ul").css("padding", "0");

                        $("#AnoncementArea ul.mobileSlide").append("<li style='display:block;'><img src='" + dt[i].ImagePath + "' style='height: 43px; width: 100%; overflow: hidden;'></li>");

                        mobileCounter++;

                        $("body").addClass("ActiveAnoncementBanner");
                        $("#AnoncementArea").addClass("ActiveAnoncement");
                    }
                }
            }
        }
    });

}


function RememberCheck() {
    $(".RememberCheck #cbox").on("change", function () {
        if ($(this).prop("checked")) {
            $(".RememberCheck .customCheck").addClass("checked");
        } else {
            $(".RememberCheck .customCheck").removeClass("checked");
        }
    });
}


function setCookie(cookieName, cookieValue) {

    var expiresDate = new Date();
    expiresDate.setTime(expiresDate.getTime() + 1000 * 60 * 60 * 24);
    $.cookie(cookieName, cookieValue, { path: '/', expires: expiresDate });

}

function getCookie(cookieName) {

    var cookieValue = $.cookie(cookieName);
    return cookieValue;
}

function removeCookie() {

    var isRemoved = $.removeCookie(cookieName);
    if (isRemoved)
        console.log('Cookie ' + cookieName + ' has been removed.');
    else
        console.log('Cookie ' + cookieName + ' not removed.');
}

function hasClass(element, className) {
    return element.classList.contains(className);
}

//$(window).load(function () {
//    $(".UseLazyLoad").Lazy();
//});

$(document).ready(function () {

    //HomeCatalogTabs();
    //settingTextBanner();
    // GetLayoutTextBanners();
    getAnoncementBanner();
    RememberCheck();

    if ($(window).width() < 767) {
        HometabSlider();
        MobileBannerFade();
    }
    else {
        newInSlick();
    }

    // Fullpage js
    var newHomeClass = document.querySelector(".NewHome");
    var forFooter = document.querySelector(".forFooter");
    var firsContainer = document.querySelector(".firstContainer");
    var video = document.getElementById('video-banner');

    var windowWidth = $(window).width();

    var $header = $("header");

    if (video) {
        video.addEventListener('loadedmetadata', function () {
            this.controls = false; // Kontrolleri gizle
        });
    }

    if (forFooter && newHomeClass && windowWidth > 992) {
        var myFullpage = new fullpage('#fullpage', {
            verticalCentered: false,
            afterLoad: function (section, origin, destination, direction) {
                if (hasClass(forFooter, 'active')) {
                    $header.addClass("footerMouseOn").css("background-color", "#f7f7f7");
                } else {
                    $header.removeClass("footerMouseOn");
                }

                if (firsContainer && hasClass(firsContainer, 'active'))
                {
                    video.play();
                }

                var sectionActive = document.querySelector(".section.active .SBanner .themeSelector");

                if (sectionActive) {
                    var themeAttributeValue = sectionActive.getAttribute('data-theme');

                    if (themeAttributeValue === 'lightBanner') {
                        $("header").addClass('lightTheme');
                    }

                    else {
                        $("header").removeClass('lightTheme');
                    }
                }

            }
        });
    }

    if ($(".HomeProducts").length > 0) {

        $("#HomeCatalogTabs .ProductList .Prd").removeClass("col-md-4");
        $("#HomeCatalogTabs .ProductList .Prd").addClass("col-md-6");

        $(".HomeProducts div.Prd > a").each(function (index) {

            var imgBG = $(this).find("img:first").attr("src");

            if (imgBG.indexOf("404") != -1 && $(this).find("img:first").attr("data-qazy-src") != undefined) {
                imgBG = $(this).find("img:first").attr("data-qazy-src");
            }

            $(this).css("background-image", "url(" + imgBG + ")");
            $(this).parent().append("<a href='" + $(this).attr("href") + "' class='GotoDetails'>" + $("#GotoDetailsVl").val() + "</a>");

        });
    }

    if (!isMobile(true)) {

        $("#CatalogTabs > li").live({
            mouseenter:
                function () {

                    $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
                    $(this).addClass("active");
                    $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");

                    var catParentName = $(this).attr("data-parent-name");

                    if (catParentName == "Yeni Sezon") {
                        catParentName = "Yeni Gelenler";
                    }
                    $(".HomeCatalogTabs > .CatFirstTab > .CatParentName > a").text(catParentName);

                    var catParentUrl = $(this).attr("data-url");
                    $(".HomeCatalogTabs > .CatFirstTab > .CatParentName > a").attr("href", catParentUrl);

                },
            mouseleave:
                function () {


                }
        });

        // $("#HomeCatalogContens .PrdImgLeft, #HomeCatalogContens .PrdImgRight").click(function () {

        //         $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
        //         $("#CatalogTabs > li").addClass("active");

        //         var catParentName = $(this).attr("data-parent-name");
        //         $(".HomeCatalogTabs > .CatFirstTab > .CatParentName > div").text(catParentName);

        //         $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");


        //});

        if ($("#CatalogTabs li[data-id='173']").length > 0) {

            $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
            $("#CatalogTabs > li").removeClass("active");

            $("#CatalogTabs li[data-id='173']").addClass("active");
            var index = $("#CatalogTabs li[data-id='173']").index();
            $("#HomeCatalogContens > div").eq(index).addClass("active");

        }


    }

    $("#CatalogTabs li").live("click", function () {

        var href = $("#MainMenu li a[data-rel='" + $("#CatalogTabs li.active").data("id") + "']").attr("href");


        if (!isMobile(true)) {

            if (href != undefined && href != null) {
                document.location.href = href;
            }

        } else if ($(this).hasClass("active")) {

            if (href != undefined && href != null) {
                document.location.href = href;
            }

        }
        else {
            $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
            $(this).addClass("active");
            $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");

            var catParentName = $(this).attr("data-parent-name");

            if (catParentName == "Yeni Sezon") {
                catParentName = "Yeni Gelenler";
            }

            $(".HomeCatalogTabs > .CatFirstTab > .CatParentName > a").text(catParentName);

            var catParentUrl = $(this).attr("data-url");
            $(".HomeCatalogTabs > .CatFirstTab > .CatParentName > a").attr("href", catParentUrl);
        }

    });

    function HometabSlider() {

        $("#HomeCatalogContens img.img2").remove();
        //$("#HomeCatalogContens .HomeProducts.HomeTabItem.active .ProductList").slick({
        $("#HomeCatalogContens .HomeProducts.HomeTabItem .ProductList").slick({
            nextArrow: '<div class="PrdHomeImgRight right-arrow"></div>',
            prevArrow: '<div class="PrdHomeImgLeft left-arrow"></div>',
            arrows: true,
            useTransform: false,
        });

    }

    function newInSlick() {
        $('.HomeProducts .ProductList').slick({
            dots: false,
            infinite: true,
            arrows: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                    }
                }
            ]
        });

    }

    function MobileBannerFade() {
        $('.AnasayfaMobileFull2').slick({
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false
        });

        $('.AnasayfaMobileFull4').slick({
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false
        });
    }

    $("#pieceBanner1, .pieceBannerMiddle1 , .pieceBannerRight1 , .pieceBannerMiddle2 , .pieceBannerRight2 ").live("click", function () {

        var href = $(this).find(".middleText").find("a").first().attr("href");

        if (href != undefined && href != null) {

            document.location.href = href;
        }

    });
    if ($("#CookieNotificationArea").length > 0) {
        $("#CookieNotificationArea .CookieLink > #CookieCloseBtn").click(function () {

            $("#CookieNotificationArea").css("display", "none");
            $("footer #Legal").css("margin-bottom", "0px");

        });

        var cookieName = 'Site1Cookie_Notification';
        var cookieValue = 'Site1Cookie_val280518';

        if (typeof getCookie(cookieName) == "undefined") {

            $("#CookieNotificationArea").css("display", "block");

            setCookie(cookieName, cookieValue);
        }
    }

    //function GetLastVisitedProducts() {

    //    if ($(".AutoGetLastVisited").length > 0) {

    //        $.ajax({
    //            type: "GET",
    //            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProducts?SpecialTo=true", 
    //            cache: false,
    //            success: function (dt) {

    //                $(".LastViewedProducts.AutoSetted").remove();

    //                if (dt != "") {

    //                    $(".AutoGetLastVisited").append(dt);

    //                    $(".LastViewedProducts .ProductList .Prd").addClass("col-sm-6");
    //                    $(".LastViewedProducts .ProductList .Prd").addClass("col-xs-12");
    //                    $(".LastViewedProducts .ProductList .Prd:gt(3)").addClass("hidden-sm");

    //                    if(   $(".LastViewedProducts .ProductList .Prd").length >= 6)
    //                    {
    //                        $(".AutoGetLastVisited").show();
    //                    }

    //                }

    //            }
    //        });
    //    }
    //}

    //GetLastVisitedProducts();

    //homebannerFull2

    $(".CareerTable #Phone2").live("click", function () {
        if ($(".CareerTable #Phone2").val() == '') {
            $(".CareerTable #Phone2").val('0');
        }

    });

    // Video mute-unmute
    $(document).on("click", ".js-video-unmute", function () {
        $('.js-video-mute').show();
        $('.js-video-unmute').hide();
        $("#video-banner").prop('muted', true);
    });

    $(document).on("click", ".js-video-mute", function () {
        $('.js-video-mute').hide();
        $('.js-video-unmute').show();
        $("#video-banner").prop('muted', false);
    });

});
function PhoneFormat() {

    $(".CareerTable #Phone2").mask("9999 999 99 99");
}
